
import NavBar from '../../components/NavBar';
import AllEvents from './AllEvents';
function Home() {
  
  return (
    <>
    <NavBar/>
    <AllEvents/>
    </>
  )
}

export default Home;